export default "__VITE_ASSET__xyMgQenT__"